export abstract class ElementsConstants {
    static ELEMENTS_CONTEXT_CHANGE_EVENT: string = 'elements.contextchange';
    static ELEMENTS_LANGUAGE_EVENT: string = 'elements.languagechange';
}
